import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useAddUserMutation,
  useFetchProfilesQuery,
  useLoginMutation,
  useVerifyOtpMutation,
  useInvitationLinkMutation,
} from "../../store/api/apiSlice";
import "../../styles/auth.css";
import { Button, Image, Input, SectionHeading } from "../../ui";
import Updsteprofil from "../forumlist/updsteprofil";
import Membership from "../../components/Membership/Membership";

const SignUp = () => {
  const { refetch: refetchProfiles } = useFetchProfilesQuery();
  const [addUser] = useAddUserMutation();
  const [verifyOtp] = useVerifyOtpMutation();
  const [login] = useLoginMutation();
  const conferenceRef = useRef();
  const [stage, setStage] = useState("signup");

  const [verifyOTP, setverifyOTP] = useState(false);

  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [avatarName, setAvatarName] = useState("");
  const [schools, setSchools] = useState([]);
  const [favSports, setFavSports] = useState([]);
  const [filteredSchoolsConferences, setFilteredSchoolsConferences] = useState(
    []
  );
  const [selectedFavoriteSports, setSelectedFavoriteSports] = useState(
    Array(3).fill("")
  );
  const [selectedConferences, setSelectedConferences] = useState(
    Array(3).fill("")
  );
  const [selectedSchools, setSelectedSchools] = useState(Array(3).fill(""));
  const [selectedGenders, setSelectedGenders] = useState(Array(3).fill(""));
  const [filteredSchools, setFilteredSchools] = useState([[], [], []]);
  const [lastName, setLastName] = useState("");
  const [invitedValue, setInvitedValue] = useState(false);
  const [active, setInActice] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [proceedLoading, setProceedLoading] = useState(false);
  const phoneRef = useRef(null);
  const checkboxRef = useRef();
  const schoolNameRef = useRef();
  const verifyOtpRef = useRef();
  const navigate = useNavigate();

  const location = useLocation();
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  useEffect(() => {
    const fetchSchools = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/university/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setSchools(data.university || []);
          setFilteredSchools([data.university || [], [], []]);
        } else {
        }
      } catch (error) {}
    };

    fetchSchools();
  }, []);
  useEffect(() => {
    const fetchFavSports = async () => {
      const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token;

      try {
        const response = await fetch(`${baseUrl}/api/sports/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setFavSports(data.sports || []);
        } else {
        }
      } catch (error) {}
    };

    fetchFavSports();
  }, []);
  const handleSchoolConferenceChange = (e) => {
    const selectedConf = e.target.value;

    const filtered = selectedConf
      ? schools.filter((school) => school.conference === selectedConf)
      : schools;

    setFilteredSchoolsConferences(filtered);
  };
  const handleSchoolSelect = (index, schoolName) => {
    const updatedSchools = [...selectedSchools];
    updatedSchools[index] = schoolName;
    setSelectedSchools(updatedSchools);
  };
  const handleConferenceChange = (index, e) => {
    const selectedConf = e.target.value;
    const updatedConferences = [...selectedConferences];
    updatedConferences[index] = selectedConf;
    setSelectedConferences(updatedConferences);

    const filtered = schools.filter(
      (school) => school.conference === selectedConf
    );
    const updatedFilteredSchools = [...filteredSchools];
    updatedFilteredSchools[index] = filtered;
    setFilteredSchools(updatedFilteredSchools);
  };
  const handleSportSelect = (index, sport) => {
    const updatedSports = [...selectedFavoriteSports];
    updatedSports[index] = sport;
    setSelectedFavoriteSports(updatedSports);
    const selectedSport = favSports.find((s) => s.name === sport);
    if (selectedSport) {
      const conferences = selectedSport.conferences || [];
      const updatedConferences = [...selectedConferences];
      updatedConferences[index] = conferences[0] || "";
      setSelectedConferences(updatedConferences);
    }
  };
  const handleSchoolChange = (event) => {
    setSelectedSchool(event.target.value);
  };
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    const limitedDigits = digits.slice(0, 10);

    const formatted = limitedDigits.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    );
    return formatted;
  };

  const randomId = location.pathname.split("/").pop();
  const [invitationLink] = useInvitationLinkMutation();
  const [fullResponse, setFullResponse] = useState(null);
  useEffect(() => {
    const fetchInvitationLink = async () => {
      if (!randomId) {
        setErrors((prev) => ({ ...prev, randomId: "Random ID is required." }));
        return;
      }
      try {
        const response = await invitationLink({ randomId }).unwrap();

        setFullResponse(response);
      } catch (err) {}
    };

    fetchInvitationLink();
  }, [randomId]);
  const [errors, setErrors] = useState({});
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const newErrors = {};

    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&!#^()";:/.<>])[A-Za-z\d@$!%*?&!#^()";:/.<>]{8,}$/;
    if (stage === "signup") {
      if (fullResponse) {
        const matchedInvitee = fullResponse.playgame.invitee_name.find(
          (invitee) => invitee.invitee_fname.trim() === firstName.trim()
        );
        setInActice(true);
        setInvitedValue(true);
        if (!matchedInvitee) {
          newErrors.firstName = "Name does not match any invitation.";
        }
      }
      if (!password) {
        newErrors.password = "Password is required.";
      } else if (!passwordRegex.test(password)) {
        newErrors.password =
          "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
      }
      if (!firstName) newErrors.firstName = "First Name is required.";
      if (!lastName) newErrors.lastName = "Last Name is required.";
      if (!email) newErrors.email = "Email is required.";
      if (!phone) newErrors.phone = "Phone number is required.";
      if (!password) newErrors.password = "Password is required.";
      if (password !== confirmPassword)
        newErrors.confirmPassword = "Passwords do not match.";
      if (!checkboxRef.current.checked)
        newErrors.terms = "You must accept the Terms and Conditions.";

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setLoading(false);
        return;
      }

      setStage("details");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        password: "Password and Confirm Password do not match.",
      }));
      setLoading(false);
      return;
    }

    if (stage === "details") {
      const favoriteSportsData = selectedFavoriteSports.map((sport, index) => {
        return {
          name: sport,
          school: selectedSchools[index] || "No school available",
          conference: selectedConferences[index] || "No conference available",
          gender: selectedGenders[index] || "male",
        };
      });

      const referredBy = fullResponse
        ? fullResponse?.inviter?.email
        : undefined;

      const userData = {
        firstName,
        middleName,
        lastName,
        avatarName,
        email,
        phone,
        password,
        is_active: active,
        isAdmin: false,

        is_game_verified: invitedValue,
        referredBy: referredBy,
        school_name: selectedSchool,
        favorite_sports: [JSON.stringify(favoriteSportsData)],
      };

      try {
        await addUser(userData).unwrap();

        toast.success("Sign-up successful! Please verify your OTP.");
        setStage("otp");
        setverifyOTP(true);
        setLoading(false);
      } catch (err) {
        const errorMessages =
          err.data?.error || "Failed to add user. Please try again.";
        const cleanedErrorMessages = errorMessages.replace(
          "User validation failed: ",
          ""
        );
        const errorFields = cleanedErrorMessages
          .split(", ")
          .map((field) => field.trim());

        const newErrors = {};
        errorFields.forEach((field) => {
          if (field.includes(": ")) {
            const [key, message] = field.split(": ");
            newErrors[key.trim()] = message
              .replace(/`/g, "")
              .replace("Path ", "")
              .trim();
          } else {
            newErrors[field.trim()] = "An unknown error occurred.";
          }
        });
        if (err.data?.msg === "email already exists") {
          setStage("signup");
          newErrors.email = "email already exists";
        }
        if (err.data?.msg === "Avatar already exists") {
          setStage("signup");
          newErrors.avatarName = "Avatar Name already exists";
        }

        setErrors(newErrors);
        setLoading(false);
      }
    }
  };

  const validateAvatarName = (name) => {
    const avatarNameRegex = /^[a-zA-Z0-9]*$/;
    if (!name || !avatarNameRegex.test(name)) {
      setErrors((prev) => ({
        ...prev,
        avatarName:
          "Avatar Name must be alphanumeric and cannot contain spaces or special characters.",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        avatarName: undefined,
      }));
    }
  };

  const handleAvatarNameChange = (e) => {
    const { value } = e.target;
    const avatarNameRegex = /^[a-zA-Z0-9]*$/;

    if (avatarNameRegex.test(value) || value === "") {
      setAvatarName(value);
      validateAvatarName(value);
    } else {
      setErrors((prev) => ({
        ...prev,
        avatarName:
          "Avatar Name must be alphanumeric and cannot contain spaces or special characters.",
      }));
    }
  };
  const handleOtpSubmit = async (e) => {
    e.stopPropagation();
    setOtpLoading(true);
    e.preventDefault();
    const otp = verifyOtpRef.current?.value || "";

    if (!email || !otp) {
      toast.error("Please provide both email and OTP.");
      setOtpLoading(false);
      return;
    }

    try {
      await verifyOtp({ email, otp }).unwrap();
      if (fullResponse) {
        const result = await login({ email, password }).unwrap();
        localStorage.setItem("token", JSON.stringify(result));
        const profileData = await refetchProfiles().unwrap();

        localStorage.setItem("user", JSON.stringify(profileData?.user));
        // const expirationTime = Date.now() + 6 * 60 * 60 * 1000; // 6 hours in milliseconds
        // localStorage.setItem("tokenExpiration", expirationTime);
        setStage("profileUpdate");
      } else {
        setStage("NotAMember");
      }

      setOtpLoading(false);
    } catch (err) {
      toast.error("OTP verification or login failed.");
      setOtpLoading(false);
    }
  };

  const handleNavigateToDashboard = () => {
    setProceedLoading(true);
    navigate("/", { replace: true });
  };
  const handleSubmitEmail = async (e) => {
    e.stopPropagation();
    setEmailLoading(true);
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email.");
      setEmailLoading(false);
      return;
    }
    try {
      const response = await fetch(`${baseUrl}/api/auth/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "secret-key": secretKey,
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (data.success) {
        toast.success("OTP sent to your email.");
        setEmailLoading(false);
      } else {
        toast.error(data.message || "Error sending OTP.");
        setEmailLoading(false);
      }
    } catch (error) {
      toast.error("Failed to send OTP.");
      setEmailLoading(false);
    }
  };
  const handlePhoneChange = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    setPhone(formattedValue);
  };
  const handleNAvigateLogin = () => {
    navigate("/login");
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&!#^()";:/.<>])[A-Za-z\d@$!%*?&!#^()";:/.<>]{8,}$/;

    if (!passwordRegex.test(newPassword)) {
      setErrors((prev) => ({
        ...prev,
        password:
          "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, password: null }));
    }
  };
  const handleCross = () => {
    setStage("signup");
    setverifyOTP(false);
  };
  return (
    <>
      <div className="authWrapper">
        <div
          className="title-section"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Image
            style={{
              width: "60px",
              height: "60px",
              marginRight: "20px",
            }}
            path="/images/headericon.png"
            alt="Logo"
          />
          <h2 className="pb-0">College Sports Fan Association</h2>
        </div>

        <div className="row formWrapper">
          <CustomForm
            onSubmit={handleAddSubmit}
            className="col-6 mx-auto Signup-form"
          >
            <div className="d-flex justify-content-between align-items-center">
              {(stage === "signup" || stage === "details") && (
                <h3 className="fieldWrapper pt-3" style={{ color: "#203864" }}>
                  Sign Up
                </h3>
              )}
              {stage === "details" && (
                <p className="buttonWrapper">
                  <Button loading={loading} onClick={() => setStage("signup")}>
                    Back
                  </Button>
                </p>
              )}
            </div>
            {stage === "signup" && (
              <>
                <div className="d-flex justify-content-between row">
                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="First Name"
                      label="First Name"
                      type="text"
                      id="firstName"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {errors.firstName && (
                      <span className="text-danger">{errors.firstName}</span>
                    )}
                  </p>

                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Middle Name"
                      label="Middle Name"
                      type="text"
                      id="Middle Name"
                      value={middleName}
                      onChange={(e) => setMiddleName(e.target.value)}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between row">
                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Last Name"
                      label="Last Name"
                      type="text"
                      id="lastName"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    {errors.lastName && (
                      <span className="text-danger">{errors.lastName}</span>
                    )}
                  </p>
                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Avatar Name"
                      label="Avatar Name"
                      type="text"
                      id="Avatar Name"
                      value={avatarName}
                      onChange={handleAvatarNameChange}
                    />
                    {errors.avatarName && (
                      <span className="text-danger">{errors.avatarName}</span>
                    )}
                  </p>
                </div>
                <div className="d-flex justify-content-between row">
                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Email"
                      label="Email"
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors.email && (
                      <span className="text-danger">{errors.email}</span>
                    )}
                  </p>
                  <p className="fieldWrapper col-6">
                    <Input
                      label="Phone No:"
                      placeholder="123-456-7890"
                      type="tel"
                      id="phone"
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                    {errors.phone && (
                      <span className="text-danger">{errors.phone}</span>
                    )}
                  </p>
                </div>
                <div className="d-flex justify-content-between row">
                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Password"
                      label="Password"
                      type="password"
                      id="password"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {errors.password && (
                      <span className="text-danger">{errors.password}</span>
                    )}
                  </p>

                  <p className="fieldWrapper col-6">
                    <Input
                      placeholder="Confirm Password"
                      label="Confirm Password"
                      type="password"
                      id="Confirmpassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {errors.confirmPassword && (
                      <span className="text-danger">
                        {errors.confirmPassword}
                      </span>
                    )}
                  </p>
                </div>

                <p style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    type="checkbox"
                    id="checkbox"
                    ref={checkboxRef}
                    style={{ marginRight: "8px" }}
                  />
                  Accept Terms and Conditions
                  <a
                    href="/termand-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "8px" }}
                  >
                    View
                  </a>
                  {errors.terms && (
                    <span className="text-danger" style={{ marginLeft: "8px" }}>
                      {errors.terms}
                    </span>
                  )}
                </p>

                <p className="Login-text">
                  Already have an account? <Link to="/login">Login</Link>
                </p>
              </>
            )}
            {stage === "details" && (
              <>
                <div className="d-flex justify-content-between row pt-4 signup_conference">
                  <p className="fieldWrapper2 col-6">
                    <label htmlFor="Favorite College" className="form-labels">
                      Conference
                    </label>
                    <select
                      id="conference"
                      ref={conferenceRef}
                      onChange={handleSchoolConferenceChange}
                      className="form-select"
                      style={{ color: "gray" }}
                    >
                      <option value="">Select a Conference</option>
                      {Array.from(
                        new Set(schools.map((school) => school.conference))
                      ).map((conference, index) => (
                        <option key={index} value={conference}>
                          {conference}
                        </option>
                      ))}
                    </select>
                  </p>

                  <p className="fieldWrapper2 col-6 ">
                    <label htmlFor="Favorite College" className="form-labels">
                      My College
                    </label>
                    <select
                      id="schoolName"
                      ref={schoolNameRef}
                      value={selectedSchool}
                      onChange={handleSchoolChange}
                      required
                      className="form-select"
                      style={{ height: "100%", color: "gray" }}
                    >
                      <option value="">Select a College</option>
                      {filteredSchoolsConferences
                      .slice() 
                      .sort((a, b) => {
                        const nameA = a.common_name || a.name;
                        const nameB = b.common_name || b.name;
                        return nameA.localeCompare(nameB); 
                      }).map((school) => (
                        <option key={school._id} value={school.name}>
                          {school.common_name?school.common_name:school.name}
                        </option>
                      ))}
                    </select>
                  </p>
                </div>

                <div className="update-content pt-4">
                  <h4>
                    3 Sports and the Associated College of that Sport I would
                    like to Follow
                  </h4>
                </div>
                <div className="d-flex justify-content-between row pt-4">
                  {[0, 1, 2].map((index) => (
                    <div className="Selector_container2" key={index}>
                      <div style={{ flex: 1, maxWidth: "100%" }}>
                        <label style={{ whiteSpace: "nowrap" }}>
                          Fav Sport {index + 1}
                        </label>
                        <select
                          value={selectedFavoriteSports[index]}
                          onChange={(e) =>
                            handleSportSelect(index, e.target.value)
                          }
                          className="form-select"
                          style={{ color: "gray" }}
                          required
                        >
                          <option value="">Select favorite sports</option>

                          {favSports.map((sport) => (
                            <option key={sport._id} value={sport.name}>
                              {sport.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{ flex: 1, maxWidth: "100%" }}>
                        <label style={{ whiteSpace: "nowrap" }}>
                          Fav Conference {index + 1}
                        </label>
                        <select
                          value={selectedConferences[index]}
                          required
                          onChange={(e) => handleConferenceChange(index, e)}
                          className="form-select"
                          style={{ color: "gray" }}
                        >
                          <option value="">Select Conference</option>

                          {Array.from(
                            new Set(schools.map((school) => school.conference))
                          ).map((conference, index) => (
                            <option key={index} value={conference}>
                              {conference}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{ flex: 1, maxWidth: "100%" }}>
                        <label style={{ whiteSpace: "nowrap" }}>
                          Fav College {index + 1}
                        </label>
                        <select
                          value={selectedSchools[index]}
                          required
                          onChange={(e) =>
                            handleSchoolSelect(index, e.target.value)
                          }
                          className="form-select mb-2"
                          style={{ color: "gray" }}
                        >
                          <option value="">Select School</option>
                          {Array.isArray(filteredSchools[index]) &&
                            filteredSchools[index]
                            .slice() 
                    .sort((a, b) => {
                      const nameA = a.common_name || a.name;
                      const nameB = b.common_name || b.name;
                      return nameA.localeCompare(nameB); 
                    }).map((school) => (
                              <option
                                key={school._id}
                                value={school.name}
                                style={{
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {school.common_name?school.common_name:school.name}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div style={{ flex: 1, maxWidth: "100%" }}>
                        <label style={{ whiteSpace: "nowrap" }}>Gender </label>
                        <select
                          placeholder="Gender"
                          name="Gender"
                          className="form-select mb-2"
                          value={selectedGenders[index] || "male"}
                          onChange={(e) => {
                            const newGenders = [...selectedGenders];
                            newGenders[index] = e.target.value;
                            setSelectedGenders(newGenders);
                          }}
                          style={{ color: "gray" }}
                          required
                        >
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="Any">Any</option>
                        </select>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
            {(stage === "signup" || stage === "details") && (
              <p className="buttonWrapper">
                <Button type="submit" loading={loading}>
                  {" "}
                  {stage === "signup" ? "Next" : "Sign Up"}
                </Button>
              </p>
            )}
          </CustomForm>
        </div>

        {stage === "otp" && (
          <CustomModal isOpen={verifyOTP} onClose={handleCross}>
            <h3
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                marginBottom: "20px",
                textAlign: "flex-start",
              }}
            >
              Verify OTP
            </h3>

            <p className="fieldWrapper">
              <Input label="Email" type="text" value={email} readOnly />
            </p>
            <p className="fieldWrapper">
              <Input label="OTP" type="text" id="otp" ref={verifyOtpRef} />
            </p>
            <div className="Resend_button">
              <Button onClick={handleOtpSubmit} loading={otpLoading}>
                Submit
              </Button>

              <Button
                outlined
                onClick={handleSubmitEmail}
                loading={emailLoading}
              >
                Resend OTP
              </Button>
            </div>
          </CustomModal>
        )}
      </div>
      {stage === "NotAMember" && (
        <div className=" mb-2">
          <div className="membership-container">
            <div className="plans">
              <div className="plan-card">
                <div className="plan-features">
                  <div className="feature">
                    We have received your request to become a member, we will
                    get back to you soon
                  </div>
                </div>
                <Button onClick={handleNAvigateLogin}>Back</Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {stage === "profileUpdate" && (
        <div className=" mb-2">
          <Updsteprofil signupMode="true" setStage={setStage} />
        </div>
      )}
      {stage === "membership" && (
        <div className=" mb-2">
          <Membership signupMode="true" />
          <div className="text-center mt-4">
            <Button
              onClick={handleNavigateToDashboard}
              loading={proceedLoading}
            >
              Skip For Now
            </Button>
          </div>
        </div>
      )}
      {stage === "Dashboard" && (
        <div className="membershipWrapper">
          <h3>Choose Your Membership</h3>
        </div>
      )}
    </>
  );
};

export default SignUp;
